import React from "react";
import { Field, useFormikContext } from "formik";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";

const sanitizeValue = (value) => {
  if (typeof value !== "string") return value;
  return DOMPurify.sanitize(value.trim(), {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: ["b", "i", "em", "strong", "u", "a", "p", "ul", "ol", "li", "br"],
    ALLOWED_ATTR: ["href", "title", "target", "rel"],
  });
};


const SafeField = ({ name, as = "input", type = "text", ...props }) => {
  const { setFieldValue } = useFormikContext();

  const handleChange = (e) => {
    const sanitized = sanitizeValue(e.target.value);
    setFieldValue(name, sanitized);
  };

  return <Field name={name} as={as} type={type} onChange={handleChange} {...props} />;
};
SafeField.propTypes = {
  name: PropTypes.string,
  as: PropTypes.any,
  type: PropTypes.any,
};
export default SafeField;
